export default "__VITE_ASSET__D63h$KGp__"